import {HgAspectRatio} from '~/design-system/hg/components'
import {type HgHeroCinematicAssetVariantProps} from './types'
import {cinematicImageVariants} from './variants'

function CinematicImage({
  layer,
  image,
  variant,
  desktopAssetSize,
  assetType,
  mobileAssetSize = 'long',
}: {
  image: React.ReactNode
  layer?: HgHeroCinematicAssetVariantProps['layer']
} & Pick<
  HgHeroCinematicAssetVariantProps,
  'variant' | 'desktopAssetSize' | 'assetType' | 'mobileAssetSize'
>) {
  const {container, imageSlot, imageWrapper} = cinematicImageVariants({
    layer,
    variant,
    desktopAssetSize,
    assetType,
    mobileAssetSize,
  })

  return (
    <div className={container()}>
      <HgAspectRatio
        classNames={{wrapper: imageWrapper(), assetWrapper: imageSlot()}}
      >
        {image}
      </HgAspectRatio>
    </div>
  )
}

export default function CinematicAspectVariant(
  props: HgHeroCinematicAssetVariantProps
) {
  // TODO: Remove when all old cinematic heroes are updated
  const variant = props.variant ?? 'old'
  const {outerContainer} = cinematicImageVariants({
    variant,
    assetType: props.assetType,
  })
  return (
    <div className={outerContainer()}>
      {props.maskImage && props.assetType === 'image' && (
        <CinematicImage
          {...props}
          layer="mask"
          image={props.maskImage}
          variant={variant}
        />
      )}
      <CinematicImage
        {...props}
        layer="background"
        image={props.backgroundAsset}
        variant={variant}
      />
      {/*
       *  Since we cannot simply target the `mask-image` CSS property because it is not animatable,
       *  we can duplicate the background image and fade it out on hover to reveal the mask effect layer.
       */}
      {props.assetType === 'image' && (
        <CinematicImage
          {...props}
          layer="fade"
          image={props.backgroundAsset}
          variant={variant}
        />
      )}
    </div>
  )
}
